document.addEventListener('DOMContentLoaded', function() {

  // Video background
  var changeSrc = 'first';
  var isMobile = false;
  var mobileVideoBreakpoint = 640;
  if ( window.innerWidth < mobileVideoBreakpoint ) {
    isMobile = true;
  }
  function responsiveVideoSrc() {
    var videos = document.querySelectorAll('.video-iframe, .html-video');
    var windowWidth = window.innerWidth;

    if ( window.innerWidth >= mobileVideoBreakpoint && isMobile ) {
      changeSrc = true;
      isMobile = false;
    }
    if ( window.innerWidth < mobileVideoBreakpoint && !isMobile ) {
      changeSrc = true;
      isMobile = true;
    }

    if ( changeSrc || changeSrc == 'first' ) {
      for (var i = 0; i < videos.length; i++) {
        var vsrc = videos[i].getAttribute('data-vsrc');
        var mvsrc = videos[i].getAttribute('data-mvsrc');
        if ( windowWidth <= mobileVideoBreakpoint ) {
          if ( videos[i].closest('.bg-container').classList.contains('bg-mobile-desktop') && mvsrc !== '' ) {
            videos[i].setAttribute('src', mvsrc);
          } else if ( !videos[i].closest('.bg-container').classList.contains('bg-mobile-desktop') ) {
            videos[i].setAttribute('src', vsrc);
          } else {
            videos[i].setAttribute('src', '');
          }
        } else {
          if ( videos[i].closest('.bg-container').classList.contains('bg-mobile-desktop') && vsrc !== '' ) {
            videos[i].setAttribute('src', vsrc);
          } else if ( vsrc !== '' ) {
            videos[i].setAttribute('src', vsrc);
          } else {
            videos[i].setAttribute('src', '');
          }
        }
      }
      changeSrc = false;
    }

  }



  function initBlock() {
    responsiveVideoSrc();

    // Background slider
    //var bgSwiper;
    var bgSliderContainers = document.querySelectorAll('.l-container__bg-slider');
    for (var i = 0; i < bgSliderContainers.length; i++) {
      var sliderDelay = bgSliderContainers[i].querySelector('.l-container__bg-slider-slides').getAttribute('data-slider-delay') * 1;
      var sliderSpeed = bgSliderContainers[i].querySelector('.l-container__bg-slider-slides').getAttribute('data-slider-speed') * 1;
      var sliderEffect = bgSliderContainers[i].querySelector('.l-container__bg-slider-slides').getAttribute('data-slider-effect');
      var autoPlay = false;
      if ( sliderDelay > 0 ) {
        autoPlay = {
          delay: sliderDelay,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        };
      }

      // If content slider exist in same container become it's slave
      var swiperOptsSlaveBG = null;
      if ( bgSliderContainers[i].parentElement.querySelector('.l-container--slider-slides') ) {
        swiperOptsSlaveBG = {
          autoplay: false
        }
      }

      var bgSwiperOpts = {
        autoplay: autoPlay,
        autoHeight: false,
        loop: false,
        speed: sliderSpeed,
        effect: sliderEffect,
        fadeEffect: {
          crossFade: true
        },

        createElements: false,
        wrapperClass: 'slider__wrapper',
        slideClass: 'slider__slide',
        slideActiveClass: 'slider__slide--active',
        slideVisibleClass: 'slider__slide--visible',
        slideNextClass: 'slider__slide--next',
        slidePrevClass: 'slider__slide--prev',
        slideDuplicateClass: 'slider__slide--duplicate',
        slideDuplicateActiveClass: 'slider__slide--duplicate-active',
        slideDuplicateNextClass: 'slider__slide--duplicate-next',
        slideDuplicatePrevClass: 'slider__slide--duplicate-prev',
        containerModifierClass: 'slider__slides--'
      }
      bgSwiperOpts = Object.assign(bgSwiperOpts, swiperOptsSlaveBG);
      const bgSwiper = new Swiper(bgSliderContainers[i].querySelector('.l-container__bg-slider-slides'), bgSwiperOpts);
    }

    // Content slider - container level
    var sliderContainers = document.querySelectorAll('.l-container--slider');
    for (var i = 0; i < sliderContainers.length; i++) {
      var sliderDelay = sliderContainers[i].querySelector('.l-container--slider-slides').getAttribute('data-slider-delay') * 1;
      var sliderSpeed = sliderContainers[i].querySelector('.l-container--slider-slides').getAttribute('data-slider-speed') * 1;
      var sliderEffect = sliderContainers[i].querySelector('.l-container--slider-slides').getAttribute('data-slider-effect');

      // If bg slider exists in same container take it's control
      var parentBgSwiper = null;
      var swiperOptsControlBG = null;
      if ( sliderContainers[i].querySelector('.l-container__bg-slider-slides') ) {
        parentBgSwiper = sliderContainers[i].querySelector('.l-container__bg-slider-slides').swiper;
        swiperOptsControlBG = {
          controller: {
            control: parentBgSwiper,
          }
        }
      }
      var autoPlay = false;
      if ( sliderDelay > 0 ) {
        autoPlay = {
          delay: sliderDelay,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        };
      }

      var swiperOpts = {
        autoplay: autoPlay,
        navigation: {
          nextEl: sliderContainers[i].querySelector('.slider__slides__button-next'),
          prevEl: sliderContainers[i].querySelector('.slider__slides__button-prev'),
          disabledClass: 'slider__slides__button-disabled',
          lockClass: 'slider__slides__button-lock',
        },
        pagination: {
          el: sliderContainers[i].querySelector('.slider__slides__pagination'),
          type: 'bullets',
          clickable: true,
          clickableClass: 'slider__slides__pagination--clickable',
          horizontalClass: 'slider__slides__pagination--horizontal',
          lockClass: 'slider__slides__pagination-lock',
          bulletClass: 'slider__slides__bullet',
          bulletActiveClass: 'slider__slides__bullet-active',
          currentClass: 'slider__slides__pagination-current',
          hiddenClass: 'slider__slides__pagination-hidden',
          modifierClass: 'slider__slides__pagination--'
        },
        autoHeight: false,
        loop: false,
        speed: sliderSpeed,
        effect: sliderEffect,
        shortSwipes: false,
        fadeEffect: {
          crossFade: true
        },
        createElements: false,
        wrapperClass: 'slider__wrapper',
        slideClass: 'slider__slide',
        slideActiveClass: 'slider__slide--active',
        slideVisibleClass: 'slider__slide--visible',
        slideNextClass: 'slider__slide--next',
        slidePrevClass: 'slider__slide--prev',
        slideDuplicateClass: 'slider__slide--duplicate',
        slideDuplicateActiveClass: 'slider__slide--duplicate-active',
        slideDuplicateNextClass: 'slider__slide--duplicate-next',
        slideDuplicatePrevClass: 'slider__slide--duplicate-prev',
        containerModifierClass: 'slider__slides--',
      }
      swiperOpts = Object.assign(swiperOpts, swiperOptsControlBG);
      const swiper = new Swiper(sliderContainers[i].querySelector('.l-container--slider-slides'), swiperOpts);

    }

    // Content carousel - row level
    var rowSliderContainers = document.querySelectorAll('.l-row__carousel');

    for (var i = 0; i < rowSliderContainers.length; i++) {
      var slidesPerViewDesktopWide = rowSliderContainers[i].querySelector('.l-row__carousel-slides').getAttribute('data-slider-spw-desktop-wide') * 1;
      var slidesPerViewDesktop = rowSliderContainers[i].querySelector('.l-row__carousel-slides').getAttribute('data-slider-spw-desktop') * 1;
      var slidesPerViewTablet = rowSliderContainers[i].querySelector('.l-row__carousel-slides').getAttribute('data-slider-spw-tablet') * 1;
      var slidesPerViewMobile = rowSliderContainers[i].querySelector('.l-row__carousel-slides').getAttribute('data-slider-spw-mobile') * 1;
      var sliderDelay = rowSliderContainers[i].querySelector('.l-row__carousel-slides').getAttribute('data-slider-delay') * 1;
      var sliderSpeed = rowSliderContainers[i].querySelector('.l-row__carousel-slides').getAttribute('data-slider-speed') * 1;

      var autoPlay = false;
      if ( sliderDelay > 0 ) {
        autoPlay = {
          delay: sliderDelay,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        };
      }

      var rowSwiperOpts = {
        autoplay: autoPlay,
        navigation: {
          nextEl: rowSliderContainers[i].querySelector('.slider__slides__button-next'),
          prevEl: rowSliderContainers[i].querySelector('.slider__slides__button-prev'),
          disabledClass: 'slider__slides__button-disabled',
          lockClass: 'slider__slides__button-lock',
        },
        pagination: {
          el: rowSliderContainers[i].querySelector('.slider__slides__pagination'),
          type: 'bullets',
          clickable: true,
          clickableClass: 'slider__slides__pagination--clickable',
          horizontalClass: 'slider__slides__pagination--horizontal',
          lockClass: 'slider__slides__pagination-lock',
          bulletClass: 'slider__slides__bullet',
          bulletActiveClass: 'slider__slides__bullet-active',
          currentClass: 'slider__slides__pagination-current',
          hiddenClass: 'slider__slides__pagination-hidden',
          modifierClass: 'slider__slides__pagination--'
        },
        autoHeight: false,
        loop: false,
        speed: sliderSpeed,
        effect: 'slide',
        shortSwipes: false,

        createElements: false,
        wrapperClass: 'slider__wrapper',
        slideClass: 'l-content-column', //  slider__slide
        slideActiveClass: 'slider__slide--active',
        slideVisibleClass: 'slider__slide--visible',
        slideNextClass: 'slider__slide--next',
        slidePrevClass: 'slider__slide--prev',
        slideDuplicateClass: 'slider__slide--duplicate',
        slideDuplicateActiveClass: 'slider__slide--duplicate-active',
        slideDuplicateNextClass: 'slider__slide--duplicate-next',
        slideDuplicatePrevClass: 'slider__slide--duplicate-prev',
        containerModifierClass: 'slider__slides--',

        slidesPerView: slidesPerViewMobile,
        spaceBetween: 18,
        slidesPerGroup: slidesPerViewMobile,
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 768px
          768: {
            slidesPerView: slidesPerViewTablet,
            spaceBetween: 40,
            slidesPerGroup: slidesPerViewTablet
          },
          // when window width is >= 1024px
          1024: {
            slidesPerView: slidesPerViewDesktop,
            spaceBetween: 40,
            slidesPerGroup: slidesPerViewDesktop
          },
          // when window width is >= 1024px
          1280: {
            slidesPerView: slidesPerViewDesktopWide,
            spaceBetween: 40,
            slidesPerGroup: slidesPerViewDesktopWide
          }
        }
      }
      const rowSwiper = new Swiper(rowSliderContainers[i].querySelector('.l-row__carousel-slides'), rowSwiperOpts);

      // Add slider__slide class to all content columns inside row carousels to make them works as slides
      var rowSliderSlides = document.querySelectorAll('.l-row__carousel-slides .l-content-column');
      for (var j = 0; j < rowSliderSlides.length; j++) {
        rowSliderSlides[j].classList.add('slider__slide');
      }
    }

    // Gallery slider - content column level
    var gallerySliders = document.querySelectorAll('.gallery-slider');

    for (var i = 0; i < gallerySliders.length; i++) {

      // Create needed wrappers and arrows
      var sliderSlides = document.createElement("div");
      sliderSlides.classList.add('slider__slides');

      var sliderWrapper = document.createElement("div");
      sliderWrapper.classList.add('slider__wrapper');

      var sliderNav = document.createElement("div");
      sliderNav.classList.add('slider__slides__pagination');
      gallerySliders[i].querySelector('.gallery').appendChild(sliderNav);

      var slides = gallerySliders[i].querySelectorAll('.gallery-item');
      for (var j = 0; j < slides.length; j++) {
        slides[j].classList.add('slider__slide');
        sliderWrapper.appendChild(slides[j]);
      }
      sliderSlides.appendChild(sliderWrapper);
      gallerySliders[i].querySelector('.gallery').appendChild(sliderSlides);

      var sliderArrow = document.createElementNS("http://www.w3.org/2000/svg",'svg');
      sliderArrow.innerHTML = '<use xlink:href="#i-chevron" />';
      var prevArrow = document.createElement("div");
      prevArrow.classList.add('slider__slides__button-prev');
      prevArrow.appendChild(sliderArrow);
      gallerySliders[i].querySelector('.gallery').appendChild(prevArrow);

      var sliderArrow2 = document.createElementNS("http://www.w3.org/2000/svg",'svg');
      sliderArrow2.innerHTML = '<use xlink:href="#i-chevron" />';
      var nextArrow = document.createElement("div");
      nextArrow.classList.add('slider__slides__button-next');
      nextArrow.appendChild(sliderArrow2);
      gallerySliders[i].querySelector('.gallery').appendChild(nextArrow);


      // Number of slides per view
      var slidesPerView = 1;
      if ( gallerySliders[i].querySelector('.gallery').classList.contains('gallery-columns-2') ) slidesPerView = 2;
      if ( gallerySliders[i].querySelector('.gallery').classList.contains('gallery-columns-3') ) slidesPerView = 3;
      if ( gallerySliders[i].querySelector('.gallery').classList.contains('gallery-columns-4') ) slidesPerView = 4;

      // Autoplay
      var autoPlay = false;
      if ( gallerySliders[i].classList.contains('gallery-slider--autoplay') ) {
        autoPlay = {
          delay: 2000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        };
      }

      var gallerySliderOpts = {
        autoplay: autoPlay,
        navigation: {
          nextEl: gallerySliders[i].querySelector('.slider__slides__button-next'),
          prevEl: gallerySliders[i].querySelector('.slider__slides__button-prev'),
          disabledClass: 'slider__slides__button-disabled',
          lockClass: 'slider__slides__button-lock',
        },
        pagination: {
          el: gallerySliders[i].querySelector('.slider__slides__pagination'),
          type: 'bullets',
          clickable: true,
          clickableClass: 'slider__slides__pagination--clickable',
          horizontalClass: 'slider__slides__pagination--horizontal',
          lockClass: 'slider__slides__pagination-lock',
          bulletClass: 'slider__slides__bullet',
          bulletActiveClass: 'slider__slides__bullet-active',
          currentClass: 'slider__slides__pagination-current',
          hiddenClass: 'slider__slides__pagination-hidden',
          modifierClass: 'slider__slides__pagination--'
        },
        autoHeight: false,
        loop: false,
        speed: 1000,
        effect: 'slide',
        shortSwipes: false,

        createElements: false,
        wrapperClass: 'slider__wrapper',
        slideClass: 'slider__slide', //
        slideActiveClass: 'slider__slide--active',
        slideVisibleClass: 'slider__slide--visible',
        slideNextClass: 'slider__slide--next',
        slidePrevClass: 'slider__slide--prev',
        slideDuplicateClass: 'slider__slide--duplicate',
        slideDuplicateActiveClass: 'slider__slide--duplicate-active',
        slideDuplicateNextClass: 'slider__slide--duplicate-next',
        slideDuplicatePrevClass: 'slider__slide--duplicate-prev',
        containerModifierClass: 'slider__slides--',

        slidesPerView: 1,
        spaceBetween: 10,
        slidesPerGroup: 1,
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 768px
          640: {
            slidesPerView: slidesPerView,
            spaceBetween: 10,
            slidesPerGroup: 1
          }
        }
      }
      const gallerySwiper = new Swiper(gallerySliders[i].querySelector('.slider__slides'), gallerySliderOpts);

    }

    // Init tabs
    if ( tabs.length ) {
      // Set firist tabs and tablinks active in all tab systems
      for (var iTabs = 0; iTabs < tabs.length; iTabs++) {
        tabs[iTabs].querySelector('.tabs__nav-item').classList.add('active');
        tabs[iTabs].querySelector('.tabs__mobile-header').classList.add('active');
        tabs[iTabs].querySelector('.tabs__nav ~ .l-row__container').classList.add('active');
      }

      // read url to preselect a tab
    }
  }



  // Tabs system
  var tabs = document.querySelectorAll('.l-container--tabs');
  var tabsLinks = document.querySelectorAll('.tabs__nav-item');
  var tabsMobileLinks = document.querySelectorAll('.tabs__mobile-header');
  var tabContents = document.querySelectorAll('.tabs__nav ~ .l-row__container');
  var tabLinkNodes = Array.prototype.slice.call( tabsLinks );
  var tabMobileLinkNodes = Array.prototype.slice.call( tabsMobileLinks );
  //var tabs = document.querySelectorAll('.l-container--tabs');
  //var tabsLinks = document.querySelectorAll('.tabs__nav-item');
  //var tabsMobileLinks = document.querySelectorAll('.tabs__mobile-header');

  if ( tabsLinks.length ) {

    for (var iTL = 0; iTL < tabsLinks.length; iTL++) {
      Utils.addEvent(tabsLinks[iTL], 'click', function(e) {
        e.preventDefault();
        var thisIndex = tabLinkNodes.indexOf( this );
        var thisTabs = this.parentElement.parentElement.parentElement; // The container element .l-container--tabs
        var thisTablinks = thisTabs.querySelectorAll('.tabs__nav-item');
        var thisTabsMobileLinks = thisTabs.querySelectorAll('.tabs__mobile-header');
        var thisTabs = thisTabs.querySelectorAll('.tabs__nav ~ .l-row__container');

        for (var iTL2 = 0; iTL2 < thisTablinks.length; iTL2++) {
          thisTablinks[iTL2].classList.remove('active');
          thisTabsMobileLinks[iTL2].classList.remove('active');
          thisTabs[iTL2].classList.remove('active');
        }

        // Set active tabs and links
        this.classList.add('active');
        tabsMobileLinks[thisIndex].classList.add('active');
        tabContents[thisIndex].classList.add('active');


      });
    }
    for (var iTML = 0; iTML < tabsMobileLinks.length; iTML++) {
      Utils.addEvent(tabsMobileLinks[iTML], 'click', function(e) {
        e.preventDefault();
        var thisIndex = tabMobileLinkNodes.indexOf( this );
        var thisTabs = this.parentElement; // The container element .l-container--tabs
        var thisTablinks = thisTabs.querySelectorAll('.tabs__nav-item');
        var thisTabsMobileLinks = thisTabs.querySelectorAll('.tabs__mobile-header');
        var thisTabs = thisTabs.querySelectorAll('.tabs__nav ~ .l-row__container');

        for (var iTML2 = 0; iTML2 < thisTablinks.length; iTML2++) {
          thisTablinks[iTML2].classList.remove('active');
          thisTabsMobileLinks[iTML2].classList.remove('active');
          thisTabs[iTML2].classList.remove('active');
        }

        // Set active tabs and links
        this.classList.add('active');
        tabsLinks[thisIndex].classList.add('active');
        tabContents[thisIndex].classList.add('active');

        /*tabTimeout = setTimeout(function() {
            tabTimeout = null;
            var tabCoords = getCoords(currentTab);
            var tabOffsetTop = tabCoords.top;
            scrollToY(tabOffsetTop, 500);
        }, 300);*/

      });
    }
  }


  initBlock();

  var debounce = function(func, wait, immediate) {
      var timeout;
      return function() {
          var context = this, args = arguments;
          clearTimeout(timeout);
          timeout = setTimeout(function() {
              timeout = null;
              if (!immediate) func.apply(context, args);
          }, wait);
          if (immediate && !timeout) func.apply(context, args);
      };
  };

  // debounced resize event
  var resizeDebounce = debounce(function() {
    responsiveVideoSrc();
  }, 100);
  window.addEventListener('resize', resizeDebounce);


  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    //console.log(window.acf);
    window.acf.addAction( 'render_block_preview/type=container', initBlock );
  }
});
